<template>
    <v-container
        class="white pa-0 pb-10 ma-0"
    >
        <v-card
            class="mt-0"
            flat
        >

            <!-------------------------------------->
            <!--            header bar            -->
            <!-------------------------------------->
            <v-row
                class="grey lighten-3 mb-3"
                no-gutters
            >
                <v-card-title
                    class="headline ml-3"
                    primary-title
                >
                    Edit Ingredient
                </v-card-title>

            <!-----    Audit Button    ----->
                <v-tooltip
                    v-if="account.account_type == 'super admin'"
                    bottom
                >
                    <template v-slot:activator="{ on: tooltip}">
                        <v-btn
                            small
                            fab
                            absolute
                            :disabled="processing"
                            @click.prevent="audited = !audited"
                            v-on="{ ...tooltip}"
                            :depressed="audited"
                            style="top: 10px; right: 120px;"
                        >
                            <v-icon
                                v-if="!audited"
                                color="error"
                            >
                                new_releases
                            </v-icon>
                            <v-icon
                                v-else
                                color="#74cf74"
                            >
                                verified
                            </v-icon>
                        </v-btn>
                    </template>
                    <span
                        v-if="selectedIngredient.audited == null"
                    >
                        Not Audited
                    </span>
                    <span
                        v-else
                    >
                        Audited {{moment(selectedIngredient.audited).format("M[/]D[/]YYYY")}}
                    </span>
                </v-tooltip>

            <!-----    Delete Button    ----->
                <v-dialog
                    v-model="deleteIngredientDialog"
                    persistent
                    width="500"
                    style="overflow-x: hidden"
                >
                    <template
                        v-slot:activator="{ on: deleteIngredient }"
                    >
                        <v-tooltip
                            bottom
                        >
                            <template v-slot:activator="{ on: tooltip}">
                                <v-btn
                                    small
                                    fab
                                    :disabled="processing"
                                    v-on="{ ...tooltip, ...deleteIngredient}"
                                    absolute
                                    style="top: 10px; right: 70px;"
                                >
                                    <v-icon
                                        v-if="!processing"
                                    >
                                        delete
                                    </v-icon>
                                    <v-progress-circular
                                        v-if="processing"
                                        :size="40"
                                        :width="6"
                                        color="#74cf74"
                                        indeterminate
                                    ></v-progress-circular>
                                </v-btn>
                            </template>
                            <span>
                                Delete
                            </span>
                        </v-tooltip>
                    </template>
                    <v-card
                        class="pb-5"
                        style="overflow-y: hidden; overflow-x: hidden"
                    >
                        <v-row
                        class="grey lighten-3"
                        >
                            <v-card-title
                                class="headline ml-3"
                                primary-title
                            >
                                Delete Ingredient
                            </v-card-title>
                            <v-btn
                                small
                                fab
                                class="mr-3 text-right"
                                absolute
                                style="top: 10px; right: 10px;"
                                @click.prevent="cancelDeleteIngredient"
                            >
                                <v-icon>
                                close
                                </v-icon>
                            </v-btn>
                        </v-row>
                        <v-row
                            no-gutters
                            class="my-5"
                            justify="center"
                        >
                            Are you sure you want to permanently delete this ingredient?
                        </v-row>
                        <v-row
                            no-gutters
                            justify="space-between"
                            class="px-5"
                        >
                            <v-btn
                                @click.prevent="cancelDeleteIngredient"
                            >
                                CANCEL
                            </v-btn>
                            <v-btn
                                @click.prevent="deleteIngredient"
                            >
                                DELETE
                            </v-btn>
                        </v-row>
                    </v-card>
                </v-dialog>

            <!-----     Close Button     ----->
                <v-tooltip
                    bottom
                >
                    <template v-slot:activator="{ on: tooltip}">
                        <v-btn
                            small
                            fab
                            :disabled="processing"
                            v-on="{ ...tooltip}"
                            absolute
                            style="top: 10px; right: 20px;"
                            @click.prevent="cancelEditIngredient"
                        >
                            <v-icon>
                                close
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>
                        Close
                    </span>
                </v-tooltip>

                <!-- <v-btn
                    absolute
                    small
                    fab
                    class="mr-3 text-right"
                    style="top: 10px; right: 10px;"
                    
                >
                    <v-icon>
                        close
                    </v-icon>
                </v-btn> -->
            </v-row>

            <!------------------------------------->
            <!--  error deleting recipe message  -->
            <!------------------------------------->
            <v-row
                v-if="deleteIngredientErrorMessage != null"
                no-gutters
                class="mx-10 mb-2 text-justify-center"
            >
                {{deleteIngredientErrorMessage}}
            </v-row>

            <!-------------------------------------->
            <!--           main content           -->
            <!-------------------------------------->
            <v-row
                class="px-5"
                no-gutters
            >
                <v-col>
                    <v-simple-table dense>
                        <template v-slot:default>
                            <tbody>
                                <tr>
                                    <td colspan="2" class="black"/>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <v-col
                                            class="mb-1 pa-0"
                                        >
                                            <v-text-field
                                                v-model="newIngredientName"
                                                label="Ingredient Name"
                                                hide-details
                                                height="30"
                                                @keydown.enter="editExistingIngredient"
                                                @keydown.esc="cancelEditIngredient"
                                            ></v-text-field>
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <v-col
                                            class="mb-1 pa-0"
                                        >
                                            <v-autocomplete
                                                v-model="storeSection"
                                                label="Section in Store"
                                                :items="storeSections"
                                                hide-details
                                                height="30"
                                                @keydown.enter="editExistingIngredient"
                                                @keydown.esc="cancelEditIngredient"
                                            ></v-autocomplete>
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <v-row
                                            no-gutters
                                        >
                                            <v-col
                                                cols="4"
                                                class="mb-1 pr-2"
                                            >
                                                <v-text-field
                                                    v-model="newIngredientUnitQuantity"
                                                    label="Quantity"
                                                    type="number"
                                                    hide-details
                                                    height="30"
                                                    @keydown.enter="editExistingIngredient"
                                                    @keydown.esc="cancelEditIngredient"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                class="mb-1 pl-2"
                                            >
                                                <v-select
                                                    v-model="newIngredientUnit"
                                                    :items="newIngredientUnit == 'count'? ['count'] : unitOptionsNew"
                                                    label="Units"
                                                    hide-details
                                                    height="30"
                                                    :disabled="newIngredientUnit == 'count'"
                                                    @keydown.enter="editExistingIngredient"
                                                    @keydown.esc="cancelEditIngredient"
                                                ></v-select>
                                            </v-col>
                                        </v-row>
                                    </td>
                                </tr>
                                <tr
                                    v-if="newIngredientUnit == 'count'"
                                >
                                    <td colspan="2">
                                        <v-col
                                            class="mb-1 pa-0"
                                        >
                                            <v-text-field
                                                v-model="newIngredientPlural"
                                                label="New Ingredient Name (Plural)"
                                                hide-details
                                                height="30"
                                                @keydown.enter="editExistingIngredient"
                                                @keydown.esc="cancelEditIngredient"
                                            ></v-text-field>
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <v-col
                                            class="mb-1 pa-0"
                                        >
                                            <v-autocomplete
                                                v-model="newIngredientAllergy"
                                                :items="newIngredientAllergy.includes('none',0) ? ['none'] : allergies"
                                                item-text="name"
                                                item-value="id"
                                                label="Allergies"
                                                item-color="#32a852"
                                                hide-details
                                                multiple
                                                height="40"
                                            >
                                                <template
                                                    v-slot:selection="{ item, index }"
                                                >
                                                    <v-chip
                                                        v-if="index < 4"
                                                    >
                                                        <span>
                                                            {{ item.name }}
                                                        </span>
                                                    </v-chip>
                                                    <span
                                                        v-if="index === 4"
                                                        class="grey--text caption"
                                                    >
                                                        (+{{ newIngredientAllergy.length - 4 }} more)
                                                    </span>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="black"/>
                                </tr>
                                <tr v-for="item in nutrition" :key="item.category">
                                    <td><div :class="[item.ml, item.fontWeight]"> {{item.category}} </div></td>
                                    <td
                                        class="text-right"
                                        width="150"
                                        height="30"
                                    >
                                        <v-text-field
                                            v-model="item.amount"
                                            :suffix="item.unit"
                                            type="number"
                                            hide-details
                                            dense
                                            solo
                                            @keydown.enter="editExistingIngredient"
                                            @keydown.esc="cancelEditIngredient"
                                        ></v-text-field>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="black"/>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <v-row
                        class="my-2 mx-5"
                        no-gutters
                    >
                        <v-col
                            class="text-right pa-0"
                        >
                            <v-btn
                                color="#74cf74"
                                class="mt-0 white--text"
                                @click.prevent="editExistingIngredient"
                                :disabled="disableSaveEditIngredient"
                            >
                                Save
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row
                        v-if="errorMessage != null"
                        no-gutters
                    >
                        <v-col
                            class="text-right mt-1 pt-0 mx-5 red--text caption"
                        >
                            {{errorMessage}}
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
    let moment = require('moment');

    export default {
        components: {
            
        },

        mounted() {

        },

        data: () => ({
            moment: moment,
            errorMessage: null,
            storeSections: [
                'Bakery'
                ,'Baking'
                ,'Condiments'
                ,'Dairy'
                ,'Frozen Foods'
                ,'Grocery'
                ,'Lunch Meat/Cheese'
                ,'Meat/Seafood'
                ,'Produce'
                ,'Snacks'
                ,'Spices'
            ],
        }),

        methods: {
            editExistingIngredient(){
                this.errorMessage = null;
                let duplicateCheck = 0;
                let max = this.ingredients.length;

                

                for (let i=0; i < max; i++){
                    if (this.ingredients[i].name.toLowerCase() == this.newIngredientName.toLowerCase() && this.ingredients[i].id != this.selectedIngredientId){
                        console.log('this.ingredients[i].id:',this.ingredients[i].id);
                        console.log('this.selectedIngredientId:',this.selectedIngredientId);
                        duplicateCheck += 1;
                    }
                }

                if (duplicateCheck == 0){
                    if (!this.disableSaveEditIngredient) {
                        this.$store.dispatch('data/editExistingIngredient',
                            {
                                id: this.selectedIngredientId,
                                name: this.newIngredientName,
                                plural: this.newIngredientPlural,
                                storeSection: this.storeSection,
                                measurementUnit: this.newIngredientUnit,
                                gramsTotalFat: (this.nutrition[0].amount/this.newIngredientUnitQuantity),
                                gramsSaturatedFat: (this.nutrition[1].amount/this.newIngredientUnitQuantity),
                                gramsTransFat: (this.nutrition[2].amount/this.newIngredientUnitQuantity),
                                gramsPolyunsaturatedFat: (this.nutrition[3].amount/this.newIngredientUnitQuantity),
                                gramsMonounsaturatedFat: (this.nutrition[4].amount/this.newIngredientUnitQuantity),
                                milligramsCholesterol: (this.nutrition[5].amount/this.newIngredientUnitQuantity),
                                milligramsSodium: (this.nutrition[6].amount/this.newIngredientUnitQuantity),
                                gramsTotalCarbohydrate: (this.nutrition[7].amount/this.newIngredientUnitQuantity),
                                gramsDietaryFiber: (this.nutrition[8].amount/this.newIngredientUnitQuantity),
                                gramsSugars: (this.nutrition[9].amount/this.newIngredientUnitQuantity),
                                gramsProtein: (this.nutrition[10].amount/this.newIngredientUnitQuantity),
                                allergy: this.newIngredientAllergy,
                                audited: this.audited,
                                route: this.currentRoute,
                            }
                        );
                        this.selectedIngredientId = null;
                    }
                } else {
                    this.errorMessage = 'Another ingredient already exists named "';
                    this.errorMessage += this.newIngredientName;
                    this.errorMessage += '"';
                }
            },
            cancelEditIngredient() {
                this.selectedIngredientId = null;
                this.errorMessage = null;
            },
            deleteIngredient() {
                this.deleteIngredientDialog = false;
                this.$store.dispatch('data/deleteIngredient',this.selectedIngredientId);
            },
            cancelDeleteIngredient() {
                this.deleteIngredientDialog = false;
            },

        },

        computed: {
            ingredients() {
                return this.$store.getters['data/ingredient'];
            },

            account() {
                return this.$store.getters['data/account']
            },

            processing: {
                get() {
                    return this.$store.getters['data/processing'];
                },
                set(value) {
                    this.$store.dispatch('data/updateProcessing',value);
                }
            },
            audited: {
                get() {
                    return this.$store.getters['data/audited'];
                },
                set(value) {
                    this.$store.dispatch('data/updateAudited',value);
                }
            },
            deleteIngredientDialog: {
                get() {
                    return this.$store.getters['data/deleteIngredientDialog'];
                },
                set(value) {
                    this.$store.dispatch('data/updateDeleteIngredientDialog',value);
                }
            },
            disableSaveEditIngredient() {
                if(this.newIngredientName == null ||
                    this.newIngredientName == '' ||
                    ((this.newIngredientPlural == null || this.newIngredientPlural == '') && this.newIngredientUnit == 'count') ||
                    this.newIngredientUnit == null ||
                    this.storeSection == null ||
                    this.storeSection == '' ||
                    this.newIngredientUnitQuantity == null ||
                    this.newIngredientUnitQuantity == '' ||
                    this.newIngredientUnit == null ||
                    this.newIngredientUnit == '' ||
                    this.nutrition[0].amount == null ||
                    this.nutrition[0].amount.length == 0 ||
                    this.nutrition[1].amount == null ||
                    this.nutrition[1].amount.length == 0 ||
                    this.nutrition[2].amount == null ||
                    this.nutrition[2].amount.length == 0 ||
                    this.nutrition[3].amount == null ||
                    this.nutrition[3].amount.length == 0 ||
                    this.nutrition[4].amount == null ||
                    this.nutrition[4].amount.length == 0 ||
                    this.nutrition[5].amount == null ||
                    this.nutrition[5].amount.length == 0 ||
                    this.nutrition[6].amount == null ||
                    this.nutrition[6].amount.length == 0 ||
                    this.nutrition[7].amount == null ||
                    this.nutrition[7].amount.length == 0 ||
                    this.nutrition[8].amount == null ||
                    this.nutrition[8].amount.length == 0 ||
                    this.nutrition[9].amount == null ||
                    this.nutrition[9].amount.length == 0 ||
                    this.nutrition[10].amount == null ||
                    this.nutrition[10].amount.length == 0
                ) {
                    return true
                } else {
                    return false
                }
            },
            selectedIngredientId: {
                get(){
                    return this.$store.getters['data/selectedIngredientId'];
                },
                set(value) {
                    this.$store.dispatch('data/updateSelectedIngredientId',value);
                }
            },
            selectedIngredient() {
                return this.$store.getters['data/selectedIngredient'];
            },
            getUnitOptions() {
                return this.$store.getters['data/conversionChart'];
            },
            unitOptionsNew() {
                let list = [];
                let max = this.getUnitOptions.length;

                for (let i = 0; i < max; i++) {
                    if (this.getUnitOptions[i].unit != 'count'){
                        list.push(this.getUnitOptions[i].unit)
                    }
                }
                return list
            },
            allergies() {
                return this.$store.getters['data/allergies'];
            },
            currentRoute() {
                return this.$route.name;
            },
            newIngredientName: {
                get(){
                    return this.$store.getters['data/newIngredientName'];
                },
                set(value) {
                    this.$store.dispatch('data/updateNewIngredientName',value);
                }
            },
            newIngredientPlural: {
                get(){
                    return this.$store.getters['data/newIngredientPlural'];
                },
                set(value) {
                    this.$store.dispatch('data/updateNewIngredientPlural',value);
                }
            },
            newIngredientUnitQuantity: {
                get(){
                    return this.$store.getters['data/newIngredientUnitQuantity'];
                },
                set(value) {
                    this.$store.dispatch('data/updateNewIngredientUnitQuantity',value);
                }
            },
            storeSection: {
                get(){
                    return this.$store.getters['data/storeSection'];
                },
                set(value) {
                    this.$store.dispatch('data/updateStoreSection',value);
                }
            },
            newIngredientUnit: {
                get(){
                    return this.$store.getters['data/newIngredientUnit'];
                },
                set(value) {
                    this.$store.dispatch('data/updateNewIngredientUnit',value);
                }
            },
            newIngredientAllergy: {
                get(){
                    return this.$store.getters['data/newIngredientAllergy'];
                },
                set(value) {
                    this.$store.dispatch('data/updateNewIngredientAllergy',value);
                }
            },
            nutrition: {
                get(){
                    return this.$store.getters['data/nutrition'];
                },
                set(value) {
                    this.$store.dispatch('data/updateNutrition',value);
                }
            },
            deleteIngredientErrorMessage() {
                return this.$store.getters['data/deleteIngredientErrorMessage'];
            },

                
        },
            
    }
</script>